const MESSAGE_STAMP =
    /^\s*\[(?:Sent|Received): [A-Z][a-z]+, [A-Z][a-z]+ \d{1,2}(?:st|nd|rd|th), \d{4} at \d{2}:\d{2} \([^)\n]+\)\]\s*/

export function withoutMessageStamp(text: string): string {
    return text.replace(MESSAGE_STAMP, "")
}

const TABLE_ROW = /^\s*\|/

export function withoutUnfinishedTable(text: string): string {
    const lines = text.split("\n")
    let firstTableLine = lines.length
    for (let i = lines.length - 1; i >= 0; i--) {
        if (TABLE_ROW.test(lines[i])) {
            firstTableLine = i
            continue
        }
        if (i === lines.length - 1 && lines[i].trim() === "") continue
        break
    }
    if (firstTableLine === lines.length) return text
    return lines.slice(0, firstTableLine).join("\n").trimEnd()
}

export function displayAnswerText({
    text,
    isStreaming,
}: {
    text: string
    isStreaming: boolean
}): string {
    const cleaned = withoutMessageStamp(text)
    return isStreaming ? withoutUnfinishedTable(cleaned) : cleaned
}
